import { IBlogResponse, ISingleBlogResponse } from "@/types/blog.type";
import { BASE_URL, STRAPI_HEADERS } from "./strapi-config";

export const getBlogs = (
  locale: string,
  category: string | null,
  featured: boolean
): Promise<IBlogResponse> => {
  return fetch(
    `${BASE_URL}/blogs?locale=${encodeURIComponent(locale)}&populate[0]=blog_tags&populate[1]=localizations&populate[2]=poster&populate[3]=blog_categories${
      category ? `&filters[blog_categories][name][$eq]=${encodeURIComponent(category)}` : ""
    }${featured ? `&filters[featured][$eq]=true` : ""}`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: IBlogResponse) => {
      return data;
    });
};

export const getBlog = (
  locale: string,
  id: number
): Promise<ISingleBlogResponse> => {
  return fetch(
    `${BASE_URL}/blogs/${encodeURIComponent(id)}?locale=${encodeURIComponent(locale)}&populate[0]=blog_tags&populate[1]=localizations&populate[2]=poster&populate[3]=blog_categories&populate[4]=seo`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: ISingleBlogResponse) => {
      return data;
    });
};

export const getBlogBySlug = (
  slug: string,
  lng: string
): Promise<IBlogResponse> => {
  return fetch(
    `${BASE_URL}/blogs?locale=${encodeURIComponent(lng)}&filters[slug][$eq]=${encodeURIComponent(slug)}`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: IBlogResponse) => {
      return data;
    });
};

export const getAllBlogs = (): Promise<IBlogResponse> => {
  return fetch(`${BASE_URL}/blogs`, STRAPI_HEADERS)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: IBlogResponse) => {
      return data;
    });
};
